import React, { useMemo } from 'react';
import ChatGroup from '../../CopilotChatView/LeftPanel/ChatGroup';
import './ChatHistoryList.css';

const ChatHistoryList = ({
  chats = [],
  selectedChatId,
  onChatSelect,
  instruments = {},
  onDeleteChat,
}) => {
  const sortedChats = useMemo(() => {
    const sortedChats = [...chats].sort((a, b) => b.updated_at - a.updated_at);
    return sortedChats;
  }, [chats]);

  return (
    <div className="mobile-chat-history">
      <div className="mobile-chat-history-list">
        <ChatGroup
          chats={sortedChats}
          selectedChatId={selectedChatId}
          onChatSelect={onChatSelect}
          instruments={instruments}
          onDeleteChat={onDeleteChat}
        />
      </div>
    </div>
  );
};

export default ChatHistoryList;
